import React from 'react';
import { getCurrentUserId } from '../../../utils/session';
import { isAdmin } from '../../../config/learners';

// 演習画面の右上（説明シートの上）に出す学習者番号。演習の途中でも自分の番号を確かめられるようにする。
// Home の LearnerBadge と違い表示だけ：演習中にログアウトすると進み具合が消えるため、番号の変更は Home で行う。
function LearnerNumberTag() {
  const userId = getCurrentUserId();
  const label = userId == null ? '番号' : isAdmin(userId) ? '管理者' : 'あなたの番号';
  return (
    <p className="learner-number-tag">
      <span className="learner-number-tag__label">{label}</span>
      <span className="learner-number-tag__number">{userId == null ? 'なし' : userId}</span>
    </p>
  );
}

export default LearnerNumberTag;
